import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function ContactPage() {
  const [contactData, setContactData] = useState({
    address: 'Halkalı Merkez Mah. 1. Çeşme Sok. No: 13/E Küçükçekmece / İstanbul',
    phone: '0 532 500 38 69',
    email: 'info@kareyapıinsaat.com',
    workingHours: 'Pazartesi - Cumartesi: 09:00 - 18:00\nPazar: Kapalı',
    mapIframeUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.2345678901234!2d28.7856789!3d40.9876543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDU5JzE1LjYiTiAyOMKwNDcnMDguNCJF!5e0!3m2!1str!2str!4v1234567890123!5m2!1str!2str',
    facebook: 'https://www.facebook.com/kareyapiinsaat',
    instagram: 'https://www.instagram.com/kamerun_insaat?igsh=MWFqNTkyMmU3eGRlYg%3D%3D',
    twitter: '',

    youtube: 'https://www.youtube.com/kareyapiinsaat'
  });
  const [loading, setLoading] = useState(true); // Assuming a loading state is needed for setLoading(false)

  useEffect(() => {
    window.scrollTo(0, 0);
    const unsub = onSnapshot(doc(db, 'settings', 'contact'), (document) => {
      if (document.exists()) {
        const data = document.data();
        data.address = 'Halkalı Merkez Mah. 1. Çeşme Sok. No: 13/E Küçükçekmece / İstanbul';
        data.instagram = 'https://www.instagram.com/kamerun_insaat?igsh=MWFqNTkyMmU3eGRlYg%3D%3D';
        setContactData(prev => ({ ...prev, ...data }));
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const validateForm = () => {
    const newErrors: Record<string, string> = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Ad Soyad gereklidir';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Telefon gereklidir';
    } else if (!/^[0-9\s\-\+\(\)]+$/.test(formData.phone)) {
      newErrors.phone = 'Geçerli bir telefon numarası giriniz';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'E-posta gereklidir';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Geçerli bir e-posta adresi giriniz';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Mesaj gereklidir';
    } else if (formData.message.length > 500) {
      newErrors.message = 'Mesaj 500 karakterden fazla olamaz';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('phone', formData.phone);
      formBody.append('email', formData.email);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d6rcp76a739gopmlhjl0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', phone: '', email: '', message: '' });
        setErrors({});
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      {/* Hero Banner */}
      <div className="relative h-64 md:h-80 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://www.kayalarparkinsaat.com/tema/c/images/uzun3.jpg" 
            alt="İletişim - KARE YAPI" 
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="relative z-10 text-center text-white px-4 flex flex-col items-center">
          <nav className="text-sm mb-4 font-medium">
            <a href="/" className="hover:text-red-400 transition-colors">Ana Sayfa</a>
            <span className="mx-2 text-gray-400">/</span>
            <span className="text-gray-200">İletişim</span>
          </nav>
          <h1 className="text-4xl md:text-5xl font-bold drop-shadow-lg tracking-tight" style={{ fontFamily: 'Raleway, sans-serif' }}>
            İletişim
          </h1>
          <p className="mt-4 text-lg text-gray-200 drop-shadow max-w-xl">Bizimle iletişime geçin, size yardımcı olmaktan mutluluk duyarız</p>
        </div>
      </div>

      {/* Contact Content */}
      <div className="flex-1 py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            
            {/* Contact Form */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Bize Ulaşın</h2>
              
              {submitStatus === 'success' && (
                <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg text-green-800">
                  <i className="ri-checkbox-circle-line text-xl mr-2"></i>
                  Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-800">
                  <i className="ri-error-warning-line text-xl mr-2"></i>
                  Bir hata oluştu. Lütfen tekrar deneyin.
                </div>
              )}

              <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Ad Soyad <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className={`w-full px-4 py-3 border ${errors.name ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition text-sm`}
                    placeholder="Adınız ve soyadınız"
                  />
                  {errors.name && <p className="mt-1 text-sm text-red-500">{errors.name}</p>}
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Telefon <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className={`w-full px-4 py-3 border ${errors.phone ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition text-sm`}
                    placeholder="0555 123 45 67"
                  />
                  {errors.phone && <p className="mt-1 text-sm text-red-500">{errors.phone}</p>}
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    E-posta <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`w-full px-4 py-3 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition text-sm`}
                    placeholder="ornek@email.com"
                  />
                  {errors.email && <p className="mt-1 text-sm text-red-500">{errors.email}</p>}
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    Mesajınız <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    maxLength={500}
                    className={`w-full px-4 py-3 border ${errors.message ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition resize-none text-sm`}
                    placeholder="Mesajınızı buraya yazın..."
                  />
                  <div className="flex justify-between items-center mt-1">
                    {errors.message && <p className="text-sm text-red-500">{errors.message}</p>}
                    <p className="text-xs text-gray-500 ml-auto">{formData.message.length}/500</p>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-teal-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-teal-700 transition disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin mr-2"></i>
                      Gönderiliyor...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line mr-2"></i>
                      Mesaj Gönder
                    </>
                  )}
                </button>
              </form>
            </div>

            {/* Contact Information */}
            <div className="space-y-8">
              {/* Company Info */}
              <div className="bg-white rounded-lg shadow-lg p-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">İletişim Bilgileri</h2>
                
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold text-gray-800 mb-1">Adres</h3>
                      <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">
                        {contactData.address}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-2xl text-teal-600"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold text-gray-800 mb-1">Telefon</h3>
                      <a href={`tel:${contactData.phone.replace(/\s+/g, '')}`} className="text-teal-600 hover:text-teal-700 text-sm font-bold tracking-widest">
                        {contactData.phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-2xl text-teal-600"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold text-gray-800 mb-1">E-posta</h3>
                      <a href={`mailto:${contactData.email}`} className="text-teal-600 hover:text-teal-700 text-sm">
                        {contactData.email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-2xl text-teal-600"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold text-gray-800 mb-1">Çalışma Saatleri</h3>
                      <p className="text-gray-600 text-sm whitespace-pre-line">
                        {contactData.workingHours}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Social Media */}
                <div className="mt-8 pt-8 border-t border-gray-200">
                  <h3 className="font-semibold text-gray-800 mb-4">Sosyal Medya</h3>
                  <div className="flex flex-wrap gap-4">
                    {contactData.facebook && (
                      <a href={contactData.facebook} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-teal-600 hover:text-white transition cursor-pointer">
                        <i className="ri-facebook-fill text-xl"></i>
                      </a>
                    )}
                    {contactData.instagram && (
                      <a href={contactData.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-teal-600 hover:text-white transition cursor-pointer">
                        <i className="ri-instagram-line text-xl"></i>
                      </a>
                    )}
                    {contactData.twitter && (
                      <a href={contactData.twitter} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-teal-600 hover:text-white transition cursor-pointer">
                        <i className="ri-twitter-x-line text-xl"></i>
                      </a>
                    )}
                    {contactData.phone && (
                      <a href={`https://wa.me/90${contactData.phone.replace(/\D/g, '').replace(/^0/, '')}`} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-green-600 hover:text-white transition cursor-pointer">
                        <i className="ri-whatsapp-line text-xl"></i>
                      </a>
                    )}
                    {contactData.youtube && (
                      <a href={contactData.youtube} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-teal-600 hover:text-white transition cursor-pointer">
                        <i className="ri-youtube-fill text-xl"></i>
                      </a>
                    )}
                  </div>
                </div>
              </div>

              {/* Transportation Info */}
              <div className="bg-white rounded-lg shadow-lg p-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">Ulaşım Bilgileri</h2>
                
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-subway-line text-lg text-teal-600"></i>
                    </div>
                    <div className="ml-3">
                      <h4 className="font-semibold text-gray-800 text-sm mb-1">Metro</h4>
                      <p className="text-gray-600 text-sm">İstasyon Metro Durağı - 5 dakika yürüme mesafesinde</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-bus-line text-lg text-teal-600"></i>
                    </div>
                    <div className="ml-3">
                      <h4 className="font-semibold text-gray-800 text-sm mb-1">Otobüs</h4>
                      <p className="text-gray-600 text-sm">76A, 76T, 76Y hatları - İstasyon Durağı</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-car-line text-lg text-teal-600"></i>
                    </div>
                    <div className="ml-3">
                      <h4 className="font-semibold text-gray-800 text-sm mb-1">Araç ile</h4>
                      <p className="text-gray-600 text-sm">E-5 Karayolu üzerinden kolayca ulaşılabilir</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-train-line text-lg text-teal-600"></i>
                    </div>
                    <div className="ml-3">
                      <h4 className="font-semibold text-gray-800 text-sm mb-1">Marmaray</h4>
                      <p className="text-gray-600 text-sm">Halkalı İstasyonu - 10 dakika mesafede</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Google Maps */}
          <div className="mt-12 bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-800">Haritada Konumumuz</h2>
              <p className="text-gray-600 mt-2 text-sm">{contactData.address}</p>
            </div>
            <div className="relative w-full h-[500px]">
              {contactData.mapIframeUrl ? (
                <iframe
                  src={contactData.mapIframeUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="KARE YAPI İNŞAAT Konum"
                ></iframe>
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gray-100 text-gray-400">
                  <i className="ri-map-pin-line text-4xl mb-2 block text-center"></i>
                  Harita yüklenemedi.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
